<template>
  <BittsModal
    v-if="visible"
    variant="data"
    :show-close-button="false"
    :width="520"
    container-class="c-payment-reminder-dialog"
    :hide-footer="true"
    :closable="true"
    @closed="$emit('close')"
  >
    <template #header>
      <div class="text-center">
        <div class="mb-16">
          <BittsSvg :svg="'logoNoText'" class="h-64 mx-auto" alt="Crossbeam" />
        </div>
        <p class="text-neutral-text-strong font-bold text-xxl pb-8">
          Payment Required
        </p>
        <p class="text-neutral-text-weak text-base">
          Your organization needs to complete payment to access all Crossbeam
          features.
        </p>
      </div>
    </template>
    <div class="pt-16 pb-20 text-center">
      <div class="space-y-16">
        <div class="bg-orange-50 border border-orange-200 rounded-lg p-16">
          <p
            class="text-orange-800 font-medium flex items-center justify-center gap-8"
          >
            <svg
              class="w-16 h-16 text-orange-600"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
            </svg>
            Some features may be unavailable until this is resolved.
          </p>
        </div>

        <div class="space-y-8">
          <p class="text-neutral-text-default text-sm">
            Please contact your administrator or billing team, or reach out to:
          </p>
          <div class="text-center">
            <a
              href="mailto:support@crossbeam.com"
              class="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
            >
              <svg
                class="w-16 h-16 mr-8"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                />
              </svg>
              support@crossbeam.com
            </a>
          </div>
        </div>

        <div class="pt-16 flex justify-center">
          <BittsButton
            @click="$emit('close')"
            variant="fill"
            size="medium"
            text="Dismiss"
          />
        </div>
      </div>
    </div>
  </BittsModal>
</template>

<script setup lang="ts">
import { BittsButton, BittsModal, BittsSvg } from '@crossbeam/bitts';

defineProps<{
  visible: boolean;
}>();

defineEmits<{
  close: [];
}>();
</script>

<style lang="pcss">
@reference "../../css/theme.css";
.c-payment-reminder-dialog {
  .o-bitts-modal__header {
    @apply border-none;
  }
}
</style>
